// metodos de mutations 

export default {
  ActiveDisplay(state, val){state.display = val},
  ActiveLateral(state, val){ state.lateralShow = val;},
  set_displayEdit(state, val){
      state.displayEdit = val;
  },  
    //IngresoAuth : (state, val) => state.auth = !state.auth,
    IngresoAccount(state, val){state.account = val},
    retrieveToken(state, token ) {state.token = token;},
    IngresoDimenu(state,val){state.dimenu = val;},
    SalirDimenu(state,val){state.dimenu = false;},
    SetAppIDactual(state){state.appIDactual = localStorage.getItem('appIDactual');},
    set_privilegies(state, privilegies){
      state.privilegies = privilegies;
    },
    destroyToken(state) {
      state.token = null
      console.log('valor del token = ', state.token);
    },
    set_app_modulos(state, modulos){
      state.modulos = modulos;
    },
    SET_ORGINFO (state, orginfo) {
      state.infoorg = orginfo;
      localStorage.setItem('nomCompany', orginfo.com_company_name);
    },
    SET_ORG_All (state, orglist){
      state.orgAll = orglist
    },
    
    SELECT_ORG_ACTIVE(state, ido) {
      let data = state.orgAll.filter(x => x.id === ido).map(x => x);
      state.infoorg = data
    },
    SET_APPLIST (state, listApps){
      let apps = [];
      let privilegios = state.privilegies;
      if(window.user_type==0){ apps = listApps; }
      else
      {
        for (let i in privilegios.modulos)
        {
          if(privilegios.modulos[i].length > 0 && !isNaN(i))
          {
            for (let a in listApps)
            {
              if(listApps[a].id == i || privilegios.alls){ 
                if(listApps[a].id==1){listApps[a].icon = 'fas fa-dollar-sign';}
                if(listApps[a].id==2){listApps[a].icon = 'fas fa-globe';}
                if(listApps[a].id==3){listApps[a].icon = 'fas fa-tasks';}
                if(listApps[a].id==4){listApps[a].icon = 'fas fa-tasks';}
                if(listApps[a].id==5){listApps[a].icon = 'fas fa-tasks';}
                apps.push(listApps[a]);
              }
            }
          }
        }
      }
      //console.log('lista de app disponibles',apps);
      state.appAll = apps;
    },
    SET_SHOWASIDE(state, showAside) {
      state.showAside = showAside
    },
    exit_Apps(state){
      const access = {
        login: false,
        token: null,
      };
      state.token = access.token;
      state.token_b = access.token;
      state.dimenu = access.login;
      let a = localStorage;
      for(var i in a){
      if(a.hasOwnProperty(i))
        //console.log(i, a[i]); //imprimir variable borrada
        localStorage.removeItem(i, a[i]);
      }
    },
    SET_MENU_TAB(state, menutab) { state.menutab = menutab  },
    SET_CAT_ACTIVE(state, cat) { state.menuCatActive = cat  },
    SET_IMAGE_ACTIVE_FOOD(state, img){state.imageActiveFood = img},
    SET_CAT_DATA_ASIDE(state, data){
      state.dataAsideMenu = data
    },
    SET_ACCTION_ADD_FOOD(state, action){
    /*   state.newFoodAction = action */
     state.dataAsideMenu.existFoods = action
    },
    SET_RETORNO_ASIDE(state, cat) { 
      state.retornoAside = cat
      //state.menuCatActive.data.existSizes = cat.existSizes
    
    },
    /// specials
    SET_CURRENT_SPECIALS(state, data){
      state.SpecialsItemActive = data
    },
    SET_SPECIALS_LISTS(state, data){
      state.SpecialsLists = data
    },
    SET_ACTIONS_SPECIALS(state,data){
      state.actionUpdate = data
    },
    SET_GROUPACTIVE(state,val){
      state.groupActive = val;
    },
    SET_GROUPLIST(state,val){
      state.groupList = val;
    },
    SET_LISTCATEGORES(state,val){
      state.listCategores = val;
    },
    set_reserve(state,val){
      state.reserve = val;
    },
    set_urlWebDimenu(state,val){
      state.urlWebDimenu = val;
    },
    set_accitonPusher(state, val){ state.accitonPusher = val;  },
    setCropperImagenes(state, val){ state.cropperImagenes = val; },
    setOpenModal(state, val){ state.getOpenModal = val; },
    setCloseModal(state, val) { 
      let actionData = {}
      if (Object.keys(val).length > 0) {
        actionData = val;
      }
      state.openModal = {
        show: false,
        component: '',
        data: actionData
      }
    },    
    setLoadingModal(state, val) { state.loadingModal = val; },
    setvariantData(state, val) { state.variantData = val;},
    setvariantFoodData(state, val) { state.variantFoodData = val;},
    setnewFoodCat(state, val) { return state.newFoodCat = val;},
}
